module.exports = "/wwwroot/img/collection_vehicle_front_page.png?ver=484d6586";